import {NavLink} from "react-router-dom";
import * as React from "react";
import {CourseObject, LanguageObject} from "../../types.d";

interface CourseSidebarProps {
    basePath: string;
    courses: CourseObject[]
}

export const CourseSidebar = ({courses, basePath }: CourseSidebarProps) => {
    return <div className={'col col-3'}>
        <ul className="list-group">
            { courses.map(item => (
                <NavLink
                    key={item.id}
                    className={'list-group-item list-group-item-action'}
                    to={`${basePath}/${item.id}`}>{ item.sourceLanguage.name } -> { item.translationLanguage.name }</NavLink>
            )) }
        </ul>
    </div>
};
